interface PersonWithLightSVGProps {
  color: string;
  style: React.CSSProperties;
}

const PersonWithLightSVG = ({ color, style }: PersonWithLightSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="52"
    viewBox="0 0 56 52"
    fill="none"
  >
    <g clipPath="url(#clip0_767_2944)">
      <path
        d="M49.2971 32.4543C50.3388 34.0879 50.9502 36.0185 50.9502 38.109C50.9502 40.1995 50.3388 42.1301 49.2971 43.7637"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.875 29.5642C54.4488 32.0317 55.3659 34.9561 55.3659 38.109C55.3659 41.2619 54.4488 44.1864 52.875 46.6538"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.2175 35.813C46.6365 36.4756 46.8855 37.2638 46.8855 38.1091C46.8855 38.9545 46.6365 39.7427 46.2175 40.4053"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5858 28.4636C16.5858 30.4151 18.1567 32.0001 20.0909 32.0001H20.4088C22.343 32.0001 23.914 30.4151 23.914 28.4636L23.8686 26.7869V26.6586C23.8686 25.6325 24.3044 24.6705 25.0218 23.9467C26.2477 22.7098 27.0014 21.0057 27.0014 19.1275C27.0014 15.1328 23.6052 11.9444 19.5643 12.3384C16.3043 12.6591 13.7798 15.2519 13.5074 18.5502C13.3348 20.6758 14.1249 22.6182 15.4961 23.9742C16.2316 24.7071 16.6221 25.715 16.6221 26.7503V26.7777H20.2453"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.2454 10.7167V9.15918"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3939 11.2939L16.8672 9.81885"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9059 12.8056L13.907 11.6145"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0805 15.0959L11.7366 14.3171"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.1057 11.2939L23.6324 9.81885"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.594 12.8056L26.5929 11.6145"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.4192 15.0959L28.7631 14.3171"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.2787 38.463C29.5286 45.0658 37.5448 43.5693 37.5448 43.5693C39.9904 43.3409 41.4962 41.6844 40.4546 39.0913C39.9111 37.8461 40.4772 37.0465 40.8735 36.3382C42.0397 34.2363 40.3187 33.7679 40.3074 32.2943C40.3074 31.6546 40.8282 31.1405 41.4509 31.072C42.3907 30.9692 43.2059 30.5579 43.7041 30.0439C44.1343 29.5983 44.1796 28.9015 43.8513 28.376C39.8092 21.7389 40.3866 23.0526 39.1865 14.782C37.6014 3.66688 26.8565 -1.05105 16.6438 1.17654C1.20023 4.55791 -3.20414 20.2082 4.00816 32.6256C5.59328 35.3558 5.95559 38.7372 4.81204 41.8558L1.31345 51.3602"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M25.1921 40.1995C25.1921 40.1995 21.8294 43.8322 21.92 51.3603"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_767_2944">
        <rect width="56" height="52" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default PersonWithLightSVG;
